import * as React from 'react'
import ResponsiveUi, { ResponsiveUiProps } from '@bit/jimmijoensson.keyhole.responsive-ui'
import { useResponsiveContext } from '../../contexts/ResponsiveContext/ResponsiveContext'


export interface UiWrapperProps extends Omit<ResponsiveUiProps, 'calcHeight' | 'onResize'> {}

const UiWrapper = ({
  ...props
}: UiWrapperProps) => {
  const { setDims } = useResponsiveContext()

	return (
		<ResponsiveUi
      calcHeight={false}
      onResize={setDims}
      {...props}
    />
	)
}

export default UiWrapper